const activeClassName = 'link-list-sliders__slider-section--active';

export const onSliderSectionHeadlineClick = sliders => event => {
    const $section = $(event.target)
        .parents('.link-list-sliders__slider-section');
    const isActive = $section.hasClass(activeClassName);

    $section.toggleClass(activeClassName, !isActive);

    if (!isActive) {
        const $allSections = $('.link-list-sliders__slider-section');
        const currentSectionIndex = $allSections.index($section);
        const slider = sliders[currentSectionIndex];

        if (slider) {
            slider.update(true);
        }
        $section.find('.swiper-pagination-bullet').first().trigger('click');
    }
};

export const onSliderSectionPrevClick = sliders => event => {
    const $section = $(event.target)
        .parents('.link-list-sliders__slider-section');

    const $allSections = $('.link-list-sliders__slider-section');
    const currentSectionIndex = $allSections.index($section);
    const slider = sliders[currentSectionIndex];

    if (slider) {
        slider.update(true);
        slider.slidePrev();
    }
};

export const onSliderSectionNextClick = sliders => event => {
    const $section = $(event.target)
        .parents('.link-list-sliders__slider-section');

    const $allSections = $('.link-list-sliders__slider-section');
    const currentSectionIndex = $allSections.index($section);
    const slider = sliders[currentSectionIndex];

    if (slider) {
        slider.update(true);
        slider.slideNext();
    }
};
